import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { hot } from 'react-hot-loader';
import ErrorBoundary from '@surfline/quiver-react/dist/ErrorBoundary';

import initializeAnonymousId from '../../utils/initializeAnonymousId';
import { Perks, NotFound } from '../../containers';

class App extends Component {
  constructor(props) {
    super(props);
    const {
      identity
    } = props;
    initializeAnonymousId(identity, 'perks');
  }

  render() {
    return (
      <ErrorBoundary>
        <div>
          <Switch>
            <Route exact path="/premium-perks" component={Perks} />
            <Route path="*" component={NotFound} status={404} />
          </Switch>
        </div>
      </ErrorBoundary>
    );
  }
}

export default hot(module)(App);
